export default {
  data() {
    return {
      validators: {
        email: [
          (v) => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(v) || "Invalid e-mail";
          },
          (v) =>
            !v || v.length <= 128 || "Email must have 128 characters or less",
        ],
        startDate: [(v) => !!v || "Valid start date is required"],
        endDate: [(v) => !!v || "Valid start date is required"],
        number: [
          (v) => v >= 0 || "Must be a number greater than or equal to 0",
          (v) => v < 9999 || "Must be a number less than 9,999",
        ],
        stackDepth: [
          (v) => v > 0 || "Must be a number greater than 0",
          (v) => v < 1000000 || "Must be a number less than 1000000",
        ],
        maxCloudCover: [
          (v) => v >= 0 || "Must be a number greater than or equal to 0",
          (v) => v <= 100 || "Must be a number less or equal to 100",
        ],
        zeroToNinety: [
          (v) => v >= 0 || "Must be a number greater than or equal to 0",
          (v) => v <= 90 || "Must be a number less or equal to 100",
        ],
        required: [(v) => !!v || "Required"],
      },
    };
  },
};
